/* Swiper */
import Slider from "bootstrap-slider";

function slider_bootstrap() {

    console.log('slider bootstrap')
}

export default slider_bootstrap;